export default {
    name: 'anchored-links',
    functional: true,
    // eslint-disable-next-line no-unused-vars
    render: function (h, context) {
        if (context.props.array.length === 0) {
            return <span/>
        }
        let links_array = undefined;
        if (context.props.inner_link){
            links_array = context.props.array.map(id =>
                <span>
                    <router-link
                        to={`${context.props.part_url}${id}`}>{id}</router-link>{context.props.dec}
                </span>
            );
        } else {
            links_array = context.props.array.map(id =>
                   <span>
                       <a target="_blank" rel="noopener noreferrer"
                            href={`${context.props.part_url}${id}`}>{id}</a>{context.props.dec}
                   </span>
            );
        }
        links_array[links_array.length - 1].children.pop(); //Все страдания ради этой строки

        return links_array
    },
    props: {
        array: {
            type: Array,
            required: true
        },
        part_url: {
            type: String,
            required: true
        },
        dec: {
            type: String,
            default: ';'
        },
        inner_link: {
            type: Boolean,
            default: false
        }
    }
}

